import axios from '../../../services/axios';

const CROPWISE_API_BASE_URL = import.meta.env.VITE_APP_CROPWISE_API_URL;

export const getPropertiesByOrgId = async (
  org_id: string,
  access_token: string,
  controller?: AbortController,
) => {
  try {
    const response: any = await axios.request({
      method: 'GET',
      url: `${CROPWISE_API_BASE_URL}/v2/orgs/${org_id}/properties`,
      headers: { Authorization: `Bearer ${access_token}` },
      signal: controller?.signal,
    });
    return response.data.content;
  } catch (err: any) {
    console.error('getPropertiesByOrgId error:', err);
    return err;
  }
};
